import { requestBlob, requestJson } from './apiClient'
const BASE_PATH = '/api/instances'

const servicio = {
  listarInstancias(page = 0, size = 10, name = '') {
    const query = { page, size }
    if (name) {
      query.name = name
    }
    return requestJson({ method: 'GET', path: BASE_PATH, query })
  },
  obtenerInstanciaPorId(id) {
    return requestJson({ method: 'GET', path: `${BASE_PATH}/${id}` })
  },
  crearInstancia(payload) {
    return requestJson({ method: 'POST', path: BASE_PATH, body: payload })
  },
  actualizarInstancia(id, payload) {
    return requestJson({ method: 'PUT', path: `${BASE_PATH}/${id}`, body: payload })
  },
  eliminarInstancia(id) {
    return requestJson({ method: 'DELETE', path: `${BASE_PATH}/${id}` })
  },
  exportarInstanciasExcel(fechaReferencia) {
    return requestBlob({
      method: 'GET',
      path: `${BASE_PATH}/employee-count/export`,
      query: { fechaReferencia },
    })
  },
  exportarInstanciasPdf(fechaReferencia) {
    return requestBlob({
      method: 'GET',
      path: `${BASE_PATH}/employee-count/export/pdf`,
      query: { fechaReferencia },
    })
  },
}

export default servicio
